import { renderElement } from "../../utils/use-render.js";
import { useTooltipContext } from "./context.js";
import { forwardRef } from "react";
//#region src/ui/tooltip/shortcut.tsx
/** Keyboard shortcut hint; apply skin `className` (CSS: `media-tooltip__kbd`; Tailwind: `popup.tooltipShortcut`). */
const TooltipShortcut = forwardRef(function TooltipShortcut({ render, className, style, children, ...elementProps }, forwardedRef) {
	const { state, stateAttrMap, content } = useTooltipContext();
	const shortcut = children !== void 0 && children !== null ? children : content?.shortcut ?? null;
	if (!shortcut) return null;
	return renderElement("kbd", {
		render,
		className,
		style
	}, {
		state,
		stateAttrMap,
		ref: forwardedRef,
		props: [elementProps, { children: shortcut }]
	});
});
//#endregion
export { TooltipShortcut };

//# sourceMappingURL=shortcut.js.map